import React from 'react'
import { Files } from '@constants'

import Audio from './Audio'
import Image from './Image'
import Note from './Note'
import Code from './Code'
import PDF from './PDF'
import Sketch from './Sketch'
import Video from './Video'
import Fallback from './Fallback'

const Block = ({ file, status, light }) => {
  switch (true) {
    case Files.SUPPORTED_FILE_TYPES.AUDIOS.includes(file.type):
      return <Audio url={file.data} />
    case Files.SUPPORTED_FILE_TYPES.IMAGES.includes(file.type):
      return <Image url={file.data} />
    case Files.SUPPORTED_FILE_TYPES.CODE.includes(file.type):
      return <Code status={status} file={file} light={light} />
    case Files.SUPPORTED_FILE_TYPES.NOTE.includes(file.type):
      return <Note status={status} file={file} />
    case Files.SUPPORTED_FILE_TYPES.SKETCH.includes(file.type):
      return <Sketch status={status} file={file} light={light} />
    case Files.SUPPORTED_FILE_TYPES.PDF.includes(file.type):
      return <PDF url={file.data} />
    case Files.SUPPORTED_FILE_TYPES.VIDEOS.includes(file.type):
      return <Video url={file.data} />
    default:
      return (
        <Fallback
          url={file.data}
          name={file.name}
          type={file.type}
          visibility={file.visibility}
        />
      )
  }
}

export default Block
